// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Quiz Generator Styles - Namespaced to prevent conflicts */
.quiz-gen {
  /* Primary Colors */
  --qg-primary: #144040;
  --qg-primary-light: #1d5c5c;
  --qg-primary-hover: #0d2b2b;
  
  /* Background Colors */
  --qg-bg-light: #dcca98;
  --qg-bg-lighter: #e8dbb5;
  --qg-bg-dark: #144040;
  
  /* Text Colors */
  --qg-text-primary: #144040;
  --qg-text-secondary: #4d5d5d;
  --qg-text-light: #ffffff;
  
  /* Accent Colors */
  --qg-accent: #c4b17f;
  --qg-accent-hover: #b39c6b;
  
  /* Status Colors */
  --qg-error: #a83232;
  --qg-error-bg: #f8e6e6;
  --qg-success: #2d5a4c;
  --qg-success-bg: #e6f0ed;
  
  /* Border and Shadow */
  --qg-border: rgba(20, 64, 64, 0.2);
  --qg-shadow-sm: 0 2px 4px rgba(20, 64, 64, 0.1);
  --qg-shadow-md: 0 4px 6px rgba(20, 64, 64, 0.15);
}

.quiz-gen.quiz-generator-container {
  padding: 2rem;
  background-color: var(--qg-bg-light);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--qg-text-primary);
}

.quiz-gen .quiz-generator-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2.5rem;
  width: 100%;
  max-width: 800px;
  border-bottom: 2px solid var(--qg-primary);
  padding-bottom: 1.5rem;
}

.quiz-gen .quiz-logo {
  width: 120px;
  height: auto;
  margin-right: 1.5rem;
}

.quiz-gen .quiz-title {
  font-size: 2.5rem;
  margin: 0;
  color: var(--qg-primary);
  font-weight: 700;
}

.quiz-gen .input-section {
  background-color: var(--qg-bg-lighter);
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: var(--qg-shadow-sm);
  margin-bottom: 2rem;
  width: 100%;
  max-width: 800px;
  border: 1px solid var(--qg-primary);
}

.quiz-gen .input-group {
  margin-bottom: 2rem;
}

.quiz-gen .input-group h3 {
  color: var(--qg-primary);
  margin-bottom: 1rem;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.quiz-gen .input-group h3 svg {
  color: #144040;
}

.quiz-gen .input-container {
  position: relative;
}

.quiz-gen .input-container textarea,
.quiz-gen .input-container input,
.quiz-gen .edit-input {
  width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 3px;
  border: 2px solid var(--qg-primary);
  border-radius: 0.375rem;
  font-size: 1rem;
  background-color: #ffffff;
  color: var(--qg-text-primary);
  transition: all 0.2s ease;
}

.quiz-gen .input-container textarea:focus,
.quiz-gen .input-container input:focus,
.quiz-gen .edit-input:focus {
  outline: none;
  border-color: var(--qg-primary-light);
  box-shadow: 0 0 0 3px rgba(20, 64, 64, 0.15);
}

.quiz-gen .file-upload-icon {
  position: absolute;
  right: 1rem;
  bottom: 0.75rem;
  color: var(--qg-primary);
  cursor: pointer;
  font-size: 1.25rem;
  transition: color 0.2s ease;
  opacity: 0.8;
}

.quiz-gen .file-upload-icon:hover {
  color: var(--qg-primary);
  opacity: 1;
}

.quiz-gen .file-preview {
  margin-top: 1rem;
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 0.375rem;
  border: 1px solid var(--qg-primary);
}

.quiz-gen .generate-button,
.quiz-gen .submit-button,
.quiz-gen .export-button,
.quiz-gen .save-button,
.quiz-gen .edit-button {
  background-color: var(--qg-primary);
  color: var(--qg-text-light);
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: auto;
  min-width: 200px;
}

.quiz-gen .generate-button:hover,
.quiz-gen .submit-button:hover,
.quiz-gen .export-button:hover,
.quiz-gen .save-button:hover,
.quiz-gen .edit-button:hover {
  background-color: var(--qg-primary-hover);
  transform: translateY(-1px);
}

.quiz-gen .generate-button:disabled,
.quiz-gen .submit-button:disabled,
.quiz-gen .export-button:disabled,
.quiz-gen .save-button:disabled {
  background-color: var(--qg-text-secondary);
  cursor: not-allowed;
  transform: none;
}

.quiz-gen .quiz-content {
  background-color: var(--qg-bg-lighter);
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: var(--qg-shadow-sm);
  width: 100%;
  max-width: 800px;
  margin-top: 2rem;
  border: 1px solid var(--qg-primary);
}

.quiz-gen .error-message {
  color: var(--qg-error);
  background-color: var(--qg-error-bg);
  border: 1px solid var(--qg-error);
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  margin-top: 1rem;
  font-weight: 500;
}

.quiz-gen .success-message {
  color: var(--qg-success);
  background-color: var(--qg-success-bg);
  border: 1px solid var(--qg-success);
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  margin-top: 1rem;
  font-weight: 500;
}

.quiz-gen .export-section {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.quiz-gen .export-section select {
  width: 100%;
  max-width: 300px;
  padding: 0.75rem;
  border: 2px solid var(--qg-primary);
  border-radius: 0.375rem;
  background-color: #ffffff;
  color: var(--qg-text-primary);
}

.quiz-gen .bg-green-100 {
  background-color: var(--qg-success-bg);
  color: var(--qg-success);
  border: 1px solid var(--qg-success);
}

.quiz-gen .bg-red-100 {
  background-color: var(--qg-error-bg);
  color: var(--qg-error);
  border: 1px solid var(--qg-error);
}

/* Responsive Design */
@media (max-width: 768px) {
  .quiz-gen.quiz-generator-container {
    padding: 1rem;
  }

  .quiz-gen .quiz-title {
    font-size: 2rem;
  }

  .quiz-gen .input-section {
    padding: 1.5rem;
  }

  .quiz-gen .quiz-content {
    padding: 1.5rem;
  }

  .quiz-gen .generate-button,
  .quiz-gen .submit-button,
  .quiz-gen .export-button,
  .quiz-gen .save-button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .quiz-gen.quiz-generator-container {
    padding: 0.75rem;
  }

  .quiz-gen .quiz-title {
    font-size: 1.75rem;
  }

  .quiz-gen .input-section,
  .quiz-gen .quiz-content {
    padding: 1rem;
  }
}

/* Edit Section */
.quiz-gen .edit-section {
    margin-top: 1.5rem;
    padding: 1rem;
    background-color: var(--qg-bg-lighter);
    border-radius: 0.375rem;
    border: 1px solid var(--qg-border);
  }
  
  .quiz-gen .edit-section label {
    display: block;
    color: var(--qg-primary);
    margin-bottom: 0.5rem;
    font-weight: 500;
  }

  
/* Dark mode support 
@media (prefers-color-scheme: dark) {
  .quiz-gen.quiz-generator-container {
    background-color: var(--qg-bg-dark);
  }

  .quiz-gen .input-section,
  .quiz-gen .quiz-content {
    background-color: #1d5c5c;
    border-color: var(--qg-bg-light);
  }

  .quiz-gen .input-container textarea,
  .quiz-gen .input-container input,
  .quiz-gen .edit-input,
  .quiz-gen .export-section select {
    background-color: #144040;
    border-color: var(--qg-bg-light);
    color: var(--qg-text-light);
  }

  .quiz-gen .quiz-title,
  .quiz-gen .input-group h3 {
    color: var(--qg-bg-dark);
  }

  .quiz-gen .file-upload-icon {
    color: var(--qg-bg-light);
    opacity: 0.8;
  }

  .quiz-gen .file-upload-icon:hover {
    color: var(--qg-bg-light);
    opacity: 1;
  }

  .quiz-gen .file-preview {
    background-color: #144040;
    border-color: var(--qg-bg-light);
    color: var(--qg-text-light);
  }
}
*/`, "",{"version":3,"sources":["webpack://./src/quiz/QuizGenerator.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;;EAE3B,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;;EAErB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;;EAExB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;;EAE1B,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;;EAExB,sBAAsB;EACtB,kCAAkC;EAClC,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;;;;EAKE,mCAAmC;EACnC,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;EAKE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;;;;EAIE,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;EACjC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,mCAAmC;EACnC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;EAClB;;;AAGF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0CC","sourcesContent":["/* Quiz Generator Styles - Namespaced to prevent conflicts */\n.quiz-gen {\n  /* Primary Colors */\n  --qg-primary: #144040;\n  --qg-primary-light: #1d5c5c;\n  --qg-primary-hover: #0d2b2b;\n  \n  /* Background Colors */\n  --qg-bg-light: #dcca98;\n  --qg-bg-lighter: #e8dbb5;\n  --qg-bg-dark: #144040;\n  \n  /* Text Colors */\n  --qg-text-primary: #144040;\n  --qg-text-secondary: #4d5d5d;\n  --qg-text-light: #ffffff;\n  \n  /* Accent Colors */\n  --qg-accent: #c4b17f;\n  --qg-accent-hover: #b39c6b;\n  \n  /* Status Colors */\n  --qg-error: #a83232;\n  --qg-error-bg: #f8e6e6;\n  --qg-success: #2d5a4c;\n  --qg-success-bg: #e6f0ed;\n  \n  /* Border and Shadow */\n  --qg-border: rgba(20, 64, 64, 0.2);\n  --qg-shadow-sm: 0 2px 4px rgba(20, 64, 64, 0.1);\n  --qg-shadow-md: 0 4px 6px rgba(20, 64, 64, 0.15);\n}\n\n.quiz-gen.quiz-generator-container {\n  padding: 2rem;\n  background-color: var(--qg-bg-light);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: var(--qg-text-primary);\n}\n\n.quiz-gen .quiz-generator-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2.5rem;\n  width: 100%;\n  max-width: 800px;\n  border-bottom: 2px solid var(--qg-primary);\n  padding-bottom: 1.5rem;\n}\n\n.quiz-gen .quiz-logo {\n  width: 120px;\n  height: auto;\n  margin-right: 1.5rem;\n}\n\n.quiz-gen .quiz-title {\n  font-size: 2.5rem;\n  margin: 0;\n  color: var(--qg-primary);\n  font-weight: 700;\n}\n\n.quiz-gen .input-section {\n  background-color: var(--qg-bg-lighter);\n  padding: 2rem;\n  border-radius: 0.5rem;\n  box-shadow: var(--qg-shadow-sm);\n  margin-bottom: 2rem;\n  width: 100%;\n  max-width: 800px;\n  border: 1px solid var(--qg-primary);\n}\n\n.quiz-gen .input-group {\n  margin-bottom: 2rem;\n}\n\n.quiz-gen .input-group h3 {\n  color: var(--qg-primary);\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.quiz-gen .input-group h3 svg {\n  color: #144040;\n}\n\n.quiz-gen .input-container {\n  position: relative;\n}\n\n.quiz-gen .input-container textarea,\n.quiz-gen .input-container input,\n.quiz-gen .edit-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 3px;\n  border: 2px solid var(--qg-primary);\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  background-color: #ffffff;\n  color: var(--qg-text-primary);\n  transition: all 0.2s ease;\n}\n\n.quiz-gen .input-container textarea:focus,\n.quiz-gen .input-container input:focus,\n.quiz-gen .edit-input:focus {\n  outline: none;\n  border-color: var(--qg-primary-light);\n  box-shadow: 0 0 0 3px rgba(20, 64, 64, 0.15);\n}\n\n.quiz-gen .file-upload-icon {\n  position: absolute;\n  right: 1rem;\n  bottom: 0.75rem;\n  color: var(--qg-primary);\n  cursor: pointer;\n  font-size: 1.25rem;\n  transition: color 0.2s ease;\n  opacity: 0.8;\n}\n\n.quiz-gen .file-upload-icon:hover {\n  color: var(--qg-primary);\n  opacity: 1;\n}\n\n.quiz-gen .file-preview {\n  margin-top: 1rem;\n  background-color: #ffffff;\n  padding: 1rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--qg-primary);\n}\n\n.quiz-gen .generate-button,\n.quiz-gen .submit-button,\n.quiz-gen .export-button,\n.quiz-gen .save-button,\n.quiz-gen .edit-button {\n  background-color: var(--qg-primary);\n  color: var(--qg-text-light);\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: auto;\n  min-width: 200px;\n}\n\n.quiz-gen .generate-button:hover,\n.quiz-gen .submit-button:hover,\n.quiz-gen .export-button:hover,\n.quiz-gen .save-button:hover,\n.quiz-gen .edit-button:hover {\n  background-color: var(--qg-primary-hover);\n  transform: translateY(-1px);\n}\n\n.quiz-gen .generate-button:disabled,\n.quiz-gen .submit-button:disabled,\n.quiz-gen .export-button:disabled,\n.quiz-gen .save-button:disabled {\n  background-color: var(--qg-text-secondary);\n  cursor: not-allowed;\n  transform: none;\n}\n\n.quiz-gen .quiz-content {\n  background-color: var(--qg-bg-lighter);\n  padding: 2rem;\n  border-radius: 0.5rem;\n  box-shadow: var(--qg-shadow-sm);\n  width: 100%;\n  max-width: 800px;\n  margin-top: 2rem;\n  border: 1px solid var(--qg-primary);\n}\n\n.quiz-gen .error-message {\n  color: var(--qg-error);\n  background-color: var(--qg-error-bg);\n  border: 1px solid var(--qg-error);\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n  margin-top: 1rem;\n  font-weight: 500;\n}\n\n.quiz-gen .success-message {\n  color: var(--qg-success);\n  background-color: var(--qg-success-bg);\n  border: 1px solid var(--qg-success);\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n  margin-top: 1rem;\n  font-weight: 500;\n}\n\n.quiz-gen .export-section {\n  margin-top: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n}\n\n.quiz-gen .export-section select {\n  width: 100%;\n  max-width: 300px;\n  padding: 0.75rem;\n  border: 2px solid var(--qg-primary);\n  border-radius: 0.375rem;\n  background-color: #ffffff;\n  color: var(--qg-text-primary);\n}\n\n.quiz-gen .bg-green-100 {\n  background-color: var(--qg-success-bg);\n  color: var(--qg-success);\n  border: 1px solid var(--qg-success);\n}\n\n.quiz-gen .bg-red-100 {\n  background-color: var(--qg-error-bg);\n  color: var(--qg-error);\n  border: 1px solid var(--qg-error);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .quiz-gen.quiz-generator-container {\n    padding: 1rem;\n  }\n\n  .quiz-gen .quiz-title {\n    font-size: 2rem;\n  }\n\n  .quiz-gen .input-section {\n    padding: 1.5rem;\n  }\n\n  .quiz-gen .quiz-content {\n    padding: 1.5rem;\n  }\n\n  .quiz-gen .generate-button,\n  .quiz-gen .submit-button,\n  .quiz-gen .export-button,\n  .quiz-gen .save-button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .quiz-gen.quiz-generator-container {\n    padding: 0.75rem;\n  }\n\n  .quiz-gen .quiz-title {\n    font-size: 1.75rem;\n  }\n\n  .quiz-gen .input-section,\n  .quiz-gen .quiz-content {\n    padding: 1rem;\n  }\n}\n\n/* Edit Section */\n.quiz-gen .edit-section {\n    margin-top: 1.5rem;\n    padding: 1rem;\n    background-color: var(--qg-bg-lighter);\n    border-radius: 0.375rem;\n    border: 1px solid var(--qg-border);\n  }\n  \n  .quiz-gen .edit-section label {\n    display: block;\n    color: var(--qg-primary);\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n  }\n\n  \n/* Dark mode support \n@media (prefers-color-scheme: dark) {\n  .quiz-gen.quiz-generator-container {\n    background-color: var(--qg-bg-dark);\n  }\n\n  .quiz-gen .input-section,\n  .quiz-gen .quiz-content {\n    background-color: #1d5c5c;\n    border-color: var(--qg-bg-light);\n  }\n\n  .quiz-gen .input-container textarea,\n  .quiz-gen .input-container input,\n  .quiz-gen .edit-input,\n  .quiz-gen .export-section select {\n    background-color: #144040;\n    border-color: var(--qg-bg-light);\n    color: var(--qg-text-light);\n  }\n\n  .quiz-gen .quiz-title,\n  .quiz-gen .input-group h3 {\n    color: var(--qg-bg-dark);\n  }\n\n  .quiz-gen .file-upload-icon {\n    color: var(--qg-bg-light);\n    opacity: 0.8;\n  }\n\n  .quiz-gen .file-upload-icon:hover {\n    color: var(--qg-bg-light);\n    opacity: 1;\n  }\n\n  .quiz-gen .file-preview {\n    background-color: #144040;\n    border-color: var(--qg-bg-light);\n    color: var(--qg-text-light);\n  }\n}\n*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
